export default __webpack_public_path__ + "5ce0601ae53aa540737a76908e0b72cf.png";